"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
var _PageContext = _interopRequireDefault(require("../../context/PageContext"));
var _WebProfileContext = _interopRequireDefault(require("../../context/WebProfileContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const WebProfile = props => {
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang = "de"
  } = pageData || {};
  const [profileData, setProfileData] = (0, _react.useState)({});
  const {
    REACT_APP_PATH
  } = process.env;
  const {
    profileURL = "".concat(REACT_APP_PATH, "/api/website/profile/data")
  } = props;
  (0, _react.useEffect)(() => {
    const fetchProfileData = async () => {
      const response = await _axios.default.get("".concat(profileURL, "?lang=").concat(lang, "&fallbackLang=en"), null);
      setProfileData(response.data);
    };
    fetchProfileData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, profileURL]);
  return /*#__PURE__*/_react.default.createElement(_WebProfileContext.default.Provider, {
    value: [profileData, setProfileData]
  }, props.children);
};
var _default = exports.default = WebProfile;